export class SchedulerSetting {

    public avoidAssociationsInSameInterval: boolean = true;
    public avoidGamesBetweenSameAssociation: boolean = true;
    public avoidMultipleGamesAgainstSameAssociation: boolean = true;
    public allowGamesInAdjacentIntervals: boolean = true;
    public maxExtraIntervals: number = -1; // -1 = Auto, 0 = None, 1-5 = explicit cap
    public teamDistributionStrategy: number = 0; // 0 = Optimized, 1 = Distributed

    public clone(): SchedulerSetting {
        const clone = new SchedulerSetting();
        clone.avoidAssociationsInSameInterval = this.avoidAssociationsInSameInterval;
        clone.avoidGamesBetweenSameAssociation = this.avoidGamesBetweenSameAssociation;
        clone.avoidMultipleGamesAgainstSameAssociation = this.avoidMultipleGamesAgainstSameAssociation;
        clone.allowGamesInAdjacentIntervals = this.allowGamesInAdjacentIntervals;
        clone.maxExtraIntervals = this.maxExtraIntervals;
        clone.teamDistributionStrategy = this.teamDistributionStrategy;
        return clone;
    }
}
